(ns lupapalvelu.ui2.button
  (:require [lupapalvelu.ui2.util :refer [defuic]]
            [lupapalvelu.ui2.variant-builder :refer [builder merge-props-classes]]))

(def variants
  {:base     {:root ["inline-flex" "items-center"
                     "rounded-sm"
                     "font-bold"
                     ;; Visible 3px outline for focused elements
                     "focus-visible:outline-3 focus-visible:outline-input-stroke-focus"
                     ;; Add [--btn-border-width:x] (and a color) to a variant to add a border,
                     ;; and this is automatically subtracted from y padding for size variants.
                     "border-(length:--btn-border-width)"
                     "[--btn-border-width:0px]"]}
   :defaults {:intent :primary
              :size   :md}
   :variants {:intent   {;; NOTE: If e.g. label or stroke value is same for hover etc. pseudo state,
                         ;; as default value, just leave the default value active,
                         ;; if a Tailwind utility isn't used anywhere, it won't be included in the
                         ;; css output.
                         :primary   {:root ["bg-button-primary-fill-enabled"
                                            "text-button-primary-label-enabled"
                                            "hover:bg-button-primary-fill-hover"
                                            "active:bg-button-primary-fill-selected"
                                            "focus-visible:bg-button-primary-fill-focus focus-visible:text-button-primary-label-focus"
                                            ;; FIXME: use disabled state colors
                                            "data-disabled:text-ui-neutral-dark data-disabled:border-ui-neutral-light data-disabled:bg-ui-neutral-lighter"
                                            "uppercase"]}
                         :secondary {:root ["bg-button-secondary-fill-enabled"
                                            "[--btn-border-width:2px]"
                                            "border-button-secondary-stroke-enabled"
                                            "text-button-secondary-label-enabled"
                                            "hover:bg-button-secondary-fill-hover hover:text-button-secondary-label-hover"
                                            "active:bg-button-secondary-fill-selected"
                                            "focus-visible:bg-button-secondary-fill-focus"
                                            ;; FIXME: use disabled state colors
                                            "data-disabled:text-ui-neutral-dark data-disabled:border-ui-neutral-light data-disabled:bg-ui-neutral-lighter"
                                            "uppercase"]}
                         ;; TODO: Tertiary
                         :text      {:root ["bg-transparent"
                                            "text-text-lightbg"
                                            "hover:bg-button-primary-fill-hover/10"
                                            ;; FIXME: use disabled state colors
                                            "data-disabled:text-ui-neutral-dark "]}}
              :size     {:xs {:root ["gap-2"
                                     ;; TODO: Real xs size
                                     "leading-[1.2]"
                                     "px-3"
                                     "py-[calc(1.5*var(--spacing)-1px-var(--btn-border-width))]"]}
                         :sm {:root ["gap-2"
                                     "leading-[1.2]"
                                     "px-4"
                                     "py-[calc(2*var(--spacing)-1px-var(--btn-border-width))]"]}
                         :md {:root ["leading-none"
                                     ;; 8px gap
                                     "gap-2"
                                     ;; 16px & 15px
                                     "px-4"
                                     "py-[calc(4*var(--spacing)-1px-var(--btn-border-width))]"]}
                         :lg {:root ["leading-none"
                                     ;; TODO: Real lg size
                                     ;; 8px gap
                                     "gap-2"
                                     "text-lg"
                                     ;; 16px & 15px
                                     "px-6"
                                     "py-[calc(6*var(--spacing)-1px-var(--btn-border-width))]"]}}
              :disabled {true  {:root ["pointer-events-none"]}
                         false {}}}})

;; TODO: Should this somehow declare
;; :hover, :active, :focus ? for documentation?
(def classes
  (builder variants))

;; TODO: Util to dissoc variants flags?
;; NOTE: Disabled is both a flag, and a html element property.

(defuic button
  [props children]
  (into [(:el props :button)
         (merge-props-classes (assoc (dissoc props :intent :size :el)
                                     :data-disabled (when (:disabled props)
                                                      true))
                              ;; Coerce the boolean flags for the variants
                              (-> props
                                  (assoc :disabled (boolean (:disabled props)))
                                  (classes :root)))]
        children))
